import React, { PropsWithChildren } from "react";
import AutomationSystemsProvider, {
  AutomationSystemsProviderProps,
} from "./AutomationSystemsProvider";
import { AutomationSystems } from "../AutomationSystems";
import TicketMasterApolloClient from "../../TicketMasterApolloClient/TicketMasterApolloClient";
import "./AutomationSystemsWrapper.scss";

export interface AutomationSystemsWrapperProps
  extends PropsWithChildren<AutomationSystemsProviderProps> {
  systemType: "ticketing" | "notifications";
  title: string;
  className?: string;
  supportedProvidersTypes?: string[];
  integrationDetailsAlertText?: string | React.ReactNode;
}

const AutomationSystemsWrapper: React.FC<AutomationSystemsWrapperProps> = ({
  editTicketingSystemAllowed = true,
  apolloClient,
  endpointConfig,
  systemType,
  title,
  className,
  children,
  supportedProvidersTypes,
  integrationDetailsAlertText,
}) => {
  return (
    <div className={`automation-systems-wrapper`}>
      <TicketMasterApolloClient apolloClient={apolloClient}>
        <AutomationSystemsProvider
          editTicketingSystemAllowed={editTicketingSystemAllowed}
          apolloClient={apolloClient}
          endpointConfig={endpointConfig}
        >
          <AutomationSystems
            systemType={systemType}
            title={title}
            className={className}
            supportedProvidersTypes={supportedProvidersTypes}
            integrationDetailsAlertText={integrationDetailsAlertText}
          >
            {children}
          </AutomationSystems>
        </AutomationSystemsProvider>
      </TicketMasterApolloClient>
    </div>
  );
};

export default AutomationSystemsWrapper;
